import ReactDOM from 'react-dom/client';
import App from './App';
import { isEmbedded, syncEmbeddedBodyAttr } from './services/embedded/embeddedService';
import { initFullstory } from './services/fullstory/fullstoryService';
import { enforceEmbedOnly } from './services/embedOnlyGuard/embedOnlyGuard';

const renderApp = () => {
	// Start replay before first paint so the session (or the parent's, when embedded) sees everything.
	initFullstory();

	// In the embedded (cross-origin iframe) flow, mark <body> so the app adopts the stigg-web look.
	// Done here before first paint (not in an effect) to avoid a flash of Received-styled controls, and
	// on <body> — not the React root — because Select/MenuList/Modal portal to document.body.
	syncEmbeddedBodyAttr(isEmbedded());

	const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
	root.render(<App />);
};

// App startup, split out of index.tsx (which reads import.meta and Vite `?url` imports) so the
// wiring is unit-testable. Embed-only: a top-level load is sent to the Stigg app
// before anything renders, so no login page flashes. When it redirects we stop here — no replay,
// no React root.
export const startApp = ({ isDev }: { isDev: boolean }): void => {
	const isRedirectingToStiggApp = enforceEmbedOnly({ isDev });
	if (!isRedirectingToStiggApp) {
		renderApp();
	}
};
